import clsx from "clsx";

type Props = {
  value: string | boolean | number;
  label?: string;
  selectedValue?: string | string[] | boolean | number | undefined;
  onChange?: (value: string | string[] | boolean | number | undefined) => void;
  isFirstElementInTheList?: boolean;
  isLastElementInTheList?: boolean;
  disabled?: boolean;
  splitted?: boolean;
  multiple?: boolean;
};

export function SelectableOptionButton({
  value,
  label,
  selectedValue,
  onChange = () => {},
  isFirstElementInTheList,
  isLastElementInTheList,
  disabled,
  splitted = false,
  multiple = false,
}: Props) {
  const onOptionPressed = () => {
    if (!disabled) {
      if (multiple) {
        if (Array.isArray(selectedValue)) {
          if (selectedValue?.includes(value as string)) {
            onChange(selectedValue?.filter((item) => item !== value));
          } else {
            const newTab: string[] = [...selectedValue, value as string];
            onChange(newTab);
          }
        } else {
          onChange([value as string]);
        }
      } else {
        onChange(value);
      }
    }
  };

  const isSelected = () => {
    if (
      typeof selectedValue === "string" ||
      typeof selectedValue === "boolean" ||
      typeof selectedValue === "number"
    ) {
      return selectedValue === value;
    }

    return selectedValue?.includes(value as string);
  };

  const buttonClass = clsx(
    "flex flex-1 w-full items-center justify-center py-3 px-2 border-2 cursor-pointer",
    isSelected() ? "bg-secondary" : "bg-white",
    isFirstElementInTheList ? "rounded-l-md border-r-[1px]" : "",
    isLastElementInTheList ? "rounded-r-md border-l-[1px]" : "",
    !isFirstElementInTheList && !isLastElementInTheList && "border-x-[1px]",
    disabled && !isSelected() && "opacity-40"
  );

  const splittedButtonClass = clsx(
    "flex flex-1 w-full items-center rounded-md justify-center py-3 border-2 cursor-pointer px-2",
    isSelected() ? "bg-secondary" : "bg-white",
    "border-x-[1px]",
    disabled && !isSelected() && "opacity-40"
  );

  return (
    <div
      onClick={onOptionPressed}
      className={splitted ? splittedButtonClass : buttonClass}
    >
      <span
        className={clsx(
          "text-sm font-medium text-center",
          isSelected() ? "text-white" : "text-black"
        )}
      >
        {label ||
          (typeof value === "number" ? (value as unknown as string) : value)}
      </span>
    </div>
  );
}

export default SelectableOptionButton;
